import React, {useContext, useState} from 'react'
import PropTypes from 'prop-types'

import Button from '../../common/primitives/Button'
import SharedHostingFeatures from '../../common/primitives/SharedHostingFeatures'
import HostingBlockRecommendedTag
	from '../../common/primitives/HostingBlockRecommendedTag/HostingBlockRecommendedTag'
import {ContextCart, ContextCartProvider} from '../../context/ContextCartProvider'
import ContextSharedHostingPlanData from '../../context/ContextSharedHostingPlanData'
import styles from './ComponentSharedHostingBlock2022.scss'
import ComponentServicePrice2022 from '../ComponentServicePrice2022/ComponentServicePrice2022'
import RenderIf from '../../common/primitives/RenderIf/RenderIf'
import PriceVO from '../../valueObjects/PriceVO'
import {__t} from "../../common/lang/text-resource";

const discountStickerPositions = {
	plan_01: {
		top: -25,
		right: -21,
		rotate: -20,
	},
	plan_02: {
		top: 10,
		right: -26,
		rotate: 0,
	},
	plan_03: {
		top: -25,
		right: -21,
		rotate: 10,
	},
	plan_wpai_01: {
		top: -25,
		right: -21,
		rotate: -20,
	},
	plan_wpai_02: {
		top: 10,
		right: -26,
		rotate: 0,
	},
	plan_wpai_03: {
		top: -25,
		right: -21,
		rotate: 10,
	},
}
const discountStickerPositionsWP = {
	plan_01: {
		top: -25,
		right: -21,
		rotate: -20,
	},
	plan_02: {
		top: 10,
		right: -26,
		rotate: 0,
	},
	plan_03: {
		top: -25,
		right: -21,
		rotate: 10,
	},
}

const ComponentSharedHostingBlock2022 = (props) => {
	const {
		planId,
		addToCart,
		buttonValue,
		isWP,
		isRecommended,
		hostingPromo,
		actionContinue,
		selectedTermInit,
		customPrice,
		showStar,
		hideButton,
		hideSecondaryFeatures,
		onSelectPriceParent
	} = props

	const contextSharedHostingData = useContext(ContextSharedHostingPlanData)

	/** @type {ContextCartProvider} */
	const contextCart = useContext(ContextCart)

	const data = contextSharedHostingData.data[isWP ? planId + '_wp' : planId]
	const [selectedPrice, setSelectedPrice] = useState(new PriceVO());

	let inCart = contextCart.isNewServiceInCart(planId);
	let inCartData = contextCart.getNewServiceData(planId);

	let selectedTerm = (selectedPrice.termClear !== undefined && selectedPrice.id !== '') ? selectedPrice.termClear : selectedTermInit ?? 0;

	let addedInCartTerm = (inCartData[0] !== undefined) ? inCartData[0].termMonths : 12;
	let isAddedSelectPlanAndTerm = (inCart && selectedTerm === addedInCartTerm);

	let finalBtnValue = (isAddedSelectPlanAndTerm === true) ? __t('Добавен в количка') : buttonValue;

	/**
	 * @param {PriceVO} data
	 */
	const onSelectPrice = (data) => {
		setSelectedPrice(data);
		if (typeof onSelectPriceParent === 'function') {
			onSelectPriceParent(data);
		}
	}

	const addToCartInner = () => {

		if (typeof addToCart === 'function') {
			addToCart(planId);
			return;
		}

		if (selectedPrice.id === '') {
			return;
		}

		let breadCrumbMode = isWP ? 'PlanWP' : 'Plan';

		if (props.breadCrumbMode) {
			breadCrumbMode = props.breadCrumbMode;
		}

		if (planId === 'plan_01' && selectedPrice.termClear <= 12) {

			if (typeof props.addSSToCart === 'function') {
				props.addSSToCart(selectedPrice.id, breadCrumbMode);
				return;
			}

		}

		contextCart.addServiceToCart(selectedPrice.id, breadCrumbMode, actionContinue);
	}

	return (
	  <section
		data-test={`sharedHostingBlock-${planId}`}
		className={`${styles.container} ${styles[planId]} ${styles[planId]}`}
	  >
		  <div className={`${styles.header}`}>
			  <img src={data.icon} alt={data.name}/>
		  </div>
		  <RenderIf condition={isRecommended === true}>
			  <HostingBlockRecommendedTag text={__t('най-предпочитан')} className={styles.recommendedTag}/>
		  </RenderIf>
		  <RenderIf condition={hostingPromo === true && planId === 'plan_03'}>
			  <HostingBlockRecommendedTag text={__t('Най-добра оферта')} className={styles.recommendedTag}/>
		  </RenderIf>
		  <div className={styles.body}>
			  <h3>{data.name}</h3>
			  <div className={styles.purpose}>{data.description}</div>

			  <ComponentServicePrice2022
				showStar={showStar}
				customPrice={customPrice}
				showDiscountTag={selectedPrice.termClear === 12 && !props.hideDiscountSticker}
				showPriceSelector={props.showPriceSelector}
				serviceId={planId}
				onSelectServicePrice={onSelectPrice}
				discountStickerPositions={isWP ? discountStickerPositionsWP : discountStickerPositions}
				selectedTerm={selectedTerm}
				hostingPromo={hostingPromo}
			  />

			  {hideButton !== true && (
				<div
				  className={`${styles.buttonContainer} ${props.showPriceSelector === false ? styles.includeMarginTop : ''}`}>
					<Button
					  onClick={addToCartInner}
					  name={'do_order_for_year_start'}
					  value={finalBtnValue}
					  disabled={isAddedSelectPlanAndTerm}
					/>
				</div>
			  )}

			  <SharedHostingFeatures mainFeatures={data.mainFeatures} isMain={true}/>

			  {hideSecondaryFeatures !== true && (
				<div className={styles.biggerFeatures}>
					<SharedHostingFeatures
					  mainFeatures={data.secondaryFeatures}
					  isMain={false}
					  additionalFeatureText={props.additionalFeatureText}
					  additionalFeatureOnClick={props.additionalFeatureOnClick}
					/>
				</div>
			  )}
		  </div>
	  </section>
	)
}

ComponentSharedHostingBlock2022.defaultProps = {
	buttonValue: __t('Поръчай'),
	isWP: false,
	isRecommended: false,
	showPriceSelector: true,
	addToCart: null,
	hostingPromo: false,
	hideDiscountSticker: false,
	selectedTermInit: 1,
	hideButton: false,
	hideSecondaryFeatures: false
}
ComponentSharedHostingBlock2022.propTypes = {
	planId: PropTypes.string.isRequired,
	buttonValue: PropTypes.string,
	isWP: PropTypes.bool,
	hostingPromo: PropTypes.bool,
	isRecommended: PropTypes.bool,
	actionContinue: PropTypes.func,
	addSSToCart: PropTypes.func,
	addToCart: PropTypes.func,
	showPriceSelector: PropTypes.bool,
	hideDiscountSticker: PropTypes.bool,
	additionalFeatureText: PropTypes.string,
	additionalFeatureOnClick: PropTypes.func,
	breadCrumbMode: PropTypes.string,
	hideButton: PropTypes.bool,
	hideSecondaryFeatures: PropTypes.bool,
	onSelectPriceParent: PropTypes.func
}

export default ComponentSharedHostingBlock2022
